// JT Orthodontics (El Paso TX) - two offices: East + West.
// Backend: bondLocations.ts JT_EAST / JT_WEST (brandId "jt_orthodontics", catalog
// 4a161fdd, Edge loc 4/8, procedure 7293, DB 378). Native booking via
// ortho2-newpatient backend (WCF intake disabled - login not provisioned on DB 378).
// Bilingual (EN + ES) - El Paso market.
import type { BrandConfig } from "./types";

export const jtOrthodontics: BrandConfig = {
  slug: "jt-orthodontics",
  brandId: "jt_orthodontics",
  brandName: "JT Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/0abe1f4d-8cd4-4b41-90f3-199b3288f108.png",
  phone: "(915) 855-6616",
  phoneHref: "tel:+19158556616",
  theme: { primary: "#B8332F", primaryDark: "#2A1616" },
  locales: ["en", "es"],
  locations: {
    JT_EAST: {
      id: "JT_EAST",
      name: "East",
      addressLines: ["3030 Trawood Drive", "El Paso, TX 79936"],
      mapsUrl: "https://maps.google.com/?q=3030+Trawood+Drive+El+Paso+TX+79936",
      timezone: "America/Denver",
    },
    JT_WEST: {
      id: "JT_WEST",
      name: "West",
      addressLines: ["5551 N. Mesa, Ste A", "El Paso, TX 79912"],
      mapsUrl: "https://maps.google.com/?q=5551+N+Mesa+Ste+A+El+Paso+TX+79912",
      timezone: "America/Denver",
    },
  },
  locationAliases: { EAST: "JT_EAST", WEST: "JT_WEST" },
};
